import React from "react";
import useTableData from "./useTableData";
import ListViewCommon from "./ListViewCommon";

const headers = [
    {"label": "Meno", 'filter': 'string'},
]

function Products(props) {
    const initialFilters = [
        {
            'label': 'Meno',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Meno',
        }
    ]

    const baseUrl = '/product/manufacturers'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Meno': `/manufacturers/manufacturer/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={`/manufacturers/manufacturer`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Výrobcovia"}
        />
    )
}

export default Products
